import React from 'react';


import { useTypedTranslation } from '@app/hooks';
import { Link } from '@material-ui/core';
import { OuTree } from '@app/components';

interface IProps {
    onNext: Function;
    onCancel: Function;
    agentId: string;
}

const ConnectOU = (props: IProps) => {
    const { translation } = useTypedTranslation();

    return (
        <>
            <div className='rowcontainer'>
                <div className='dirsync__agent'>
                    <img src='/assets/images/directorysync/05-connect-ou.png'></img>
                    <div className='dirsync__agent--content'>
                        <OuTree agentId={props.agentId} />
                        <div className='dirsync__bottom--links'>
                            <Link component='button' onClick={() => props.onCancel()}>
                                {translation('DIRSYNC_CANCEL')}
                            </Link>
                            <Link component='button' onClick={() => props.onNext()}>
                                {translation('DIRSYNC_NEXT')}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ConnectOU;